/**
 * Web Font Loader takes care of Vue Design System’s font loading.
 * For full documentation, see: https://github.com/typekit/webfontloader
 */
import WebFont from "webfontloader"

WebFont.load({
    google: {
        families: ["Libre+Franklin:400,400i,500,500i,600,600i", "Montserrat:400,600,800"],
    },
})
